export default __webpack_public_path__ + "static/media/avatar_75.39b3d321.png";